import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        Markant Bridge by
        <a href="https://cellarising.hr" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Cellaris ING</a>
    </div>`
})
export class AppFooter {}
